import styled from "styled-components";

export const SectionRoot = styled.section`
    display: flex;
    flex-direction: column;
    gap: 20px;
`;

export const SectionHeader = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;

    @media (max-width: 991px) {
        align-items: flex-start;
        flex-direction: column;
    }
`;

export const SectionTitle = styled.h2`
    margin: 0;
    font-size: 32px;
    font-weight: 700;
    line-height: 1.2;
    color: ${({ theme }) => theme.palette.colors.text};

    @media (max-width: 991px) {
        font-size: 24px;
    }
`;

export const SectionAction = styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-end;
    flex-shrink: 0;

    @media (max-width: 991px) {
        width: 100%;
    }
`;

export const SectionCards = styled.div`
    width: 100%;
    min-width: 0;
    padding: 10px 0 14px;
    margin: -10px 0 -14px;

    @media (max-width: 991px) {
        padding: 0;
        margin: 0;
    }
`;
